import { useState } from "react"
import BulkItemQueueTitle from "../items/BulkItemQueueTitle"
import BulkItemsRetriesList from "../items/BulkItemsRetriesList"

const BulkItemsUpdateQueue = () => {
    const [statusSelected, setStatusSelected] = useState<string[]>([
        "Error",
        "Completado",
        "En proceso",
        "Programado",
        "Cancelado"
      ]);
  return (
    <div>
     <BulkItemQueueTitle setStatusSelected={setStatusSelected} statusSelected={statusSelected}/>
     <BulkItemsRetriesList statusSelected={statusSelected}/>
    </div>
  )
}

export default BulkItemsUpdateQueue
